module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-page"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("公司信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('v-card', [_c('h4', {
    staticClass: "page-title1"
  }, [_vm._v("公司信息")]), _vm._v(" "), _c('el-menu', {
    staticClass: "menu",
    attrs: {
      "router": true,
      "default-active": _vm.routePath
    }
  }, [_c('el-menu-item', {
    staticClass: "menu-item",
    attrs: {
      "index": "/profile/info"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v("信息维护")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "menu-item",
    attrs: {
      "index": "/profile/point"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v("服务网点维护")]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "menu-item",
    attrs: {
      "index": "/profile/engineer"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v("工程师维护")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "contract"
  }, [_c('el-row', {
    staticClass: "row"
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('p', {
    staticStyle: {
      "line-height": "22px"
    }
  }, [_vm._v("客户服务热线:0755-82405890\n              "), _c('br'), _vm._v("（人工服务时间：09:00-18:00）")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "btn btn-qq",
    attrs: {
      "href": "http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes",
      "target": "_blank"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "44px"
    },
    attrs: {
      "span": 20
    }
  }, [_vm._v("在线客服")])], 1)])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('v-card', [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a7fe116"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage.vue
// module id = 757
// module chunks = 0